module.exports = __webpack_public_path__ + "img/05-light.9d033d52.png";